import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";

// audiosprite --e "mp3,ogg" --o ../assets/audio/audiosprite *.mp3
export class AudioManager {

    private static game: Phaser.Game;
    private static audioSprite: Phaser.AudioSprite;
    private static loopPlayingKey: string;

    public static init(game: Phaser.Game): void {

        AudioManager.game = game;

        AudioManager.loopPlayingKey = null;

        AudioManager.audioSprite = AudioManager.game.add.audioSprite("audio-sprite");
        
        AudioManager.game.sound.mute = GameVars.gameData.muted;
    }

    public static mute(): void {

        GameVars.gameData.muted = true;

        AudioManager.game.sound.mute = GameVars.gameData.muted;

        GameManager.writeGameData();
    }

    public static unmute(): void {

        GameVars.gameData.muted = false;
        
        AudioManager.game.sound.mute = GameVars.gameData.muted;
        
        GameManager.writeGameData(); 
    }

    public static playSound(key: string, loop?: boolean, volume?: number): void {

        loop = loop || false;

        if (loop && key === AudioManager.loopPlayingKey) {
            return;
        }

        let sound = AudioManager.audioSprite.play(key, volume);
        sound.allowMultiple = true;
        
        if (loop) {

            if (AudioManager.loopPlayingKey && (AudioManager.loopPlayingKey !== key)) {
                AudioManager.stopSound(AudioManager.loopPlayingKey, false, true);
            }

            AudioManager.loopPlayingKey = key;
        }
    }

    public static stopSound(key: string, fade?: boolean, loop?: boolean): void {

        if (key === null || typeof key === "undefined") {
            return;
        }

        if (fade) {
            const sound = this.audioSprite.get(key);
            sound.fadeOut(850);
        } else {
            AudioManager.audioSprite.stop(key);
        }

        if (loop) {
            AudioManager.loopPlayingKey = null;
        }
    }
}

